/* Hero «La experiencia de llegar» · carrusel y movimiento · Telares · oct 2026 · v2 */
(function () {
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciar(root) {
    if (!root || root.dataset.listo) return;
    var slides = root.querySelectorAll('.hl__slide');
    if (slides.length < 2) return;
    root.dataset.listo = '1';
    var dots = root.querySelectorAll('.hl__dot');
    var actual = 0, timer = null;
    var ms = (parseInt(root.dataset.speed, 10) || 7) * 1000;

    function ir(n) {
      actual = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === actual;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, i) {
        if (i === actual) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    function andar() {
      parar();
      if (root.dataset.autoplay === 'true' && !quieto) timer = setInterval(function () { ir(actual + 1); }, ms);
    }

    slides.forEach(function (s, i) { if (i) s.setAttribute('inert', ''); });
    dots.forEach(function (d) { d.addEventListener('click', function () { ir(+d.dataset.i); andar(); }); });
    root.addEventListener('mouseenter', parar);
    root.addEventListener('mouseleave', andar);
    root.addEventListener('focusin', parar);
    root.addEventListener('focusout', andar);

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; parar(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
      x0 = null; andar();
    });

    root.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target.closest('.hl__slide'));
      if (i > -1) { ir(i); parar(); }
    });
    root.addEventListener('shopify:block:deselect', andar);
    andar();
  }

  /* Activa el movimiento (título y zoom) cuando la sección entra en pantalla */
  var obs = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('en-vista'); obs.unobserve(en.target); }
    });
  }, { threshold: 0.25 }) : null;
  function vigilar(root) {
    if (!root) return;
    if (obs) obs.observe(root); else root.classList.add('en-vista');
  }

  function todos() { document.querySelectorAll('.hl').forEach(function (r) { vigilar(r); iniciar(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.hl'); vigilar(r); iniciar(r); });
})();
